import { CommonModule }     from '@angular/common';
import { NgModule }         from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgModule }        from '@shared/components/svg/svg.module';
import { TabItemComponent } from '@shared/components/tabset/component/tab-item/tab-item.component';
import { TabsetComponent }  from '@shared/components/tabset/tabset.component';


@NgModule( {
	declarations: [
		TabsetComponent,
		TabItemComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared
		NgbTooltipModule,
		SvgModule
	],
	exports: [
		TabsetComponent,
		TabItemComponent
	]
} )
export class TabsetModule {}
